const Tabletop = require('tabletop')

function promiseTabletop(url) {
  return new Promise((resolve, reject) => {
    Tabletop.init({
      key: url,
      simpleSheet: true,
      parseNumbers: true,
      prettyColumnNames: false,
      callback: (data, tabletop) => {
        if (data) {
          resolve(data)
        } else {
          reject(error => console.log(error))
        }
      }
    })
  })
}

export default promiseTabletop



// WEBPACK FOOTER //
// ./src/helpers/promiseTabletop.js